<script>
  import { fade } from 'svelte/transition'
  import { onMount } from 'svelte'
  import LocationLink from './components/LocationLink.svelte'
  import BusIcon from './components/BusIcon.svelte'
  import PlaceIcon from './components/PlaceIcon.svelte'

  let googleSheetData, countiesList, cardData
  let selectedCounty = ''

  $: if (selectedCounty == '') {
    cardData = googleSheetData
  } else {
    cardData = googleSheetData.filter((d) => d.county.includes(selectedCounty))
  }

  onMount(async () => {
    // attribute data input
    const url = `https://datastore.thenewslens.com/infographic/china-airlines-event-footprint/data.json?${Date.now()}`
    const res = await fetch(url)

    // googleSheetData = await res.json().then((d) => gs2json(d))
    googleSheetData = await res.json()
    googleSheetData = googleSheetData.rows

    countiesList = googleSheetData
      .map((d) => d.county.split(','))
      .flat()
      .filter(onlyUnique)
  })

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index
  }

  function handleClick(e) {
    selectedCounty = e.target.dataset.county
  }
</script>

<style>
  .btn-set {
    position: sticky;
    top: 0px;
    padding: 1rem;
    z-index: 100;
    background-color: #e5f4ff;
  }
  input {
    padding: 2px 10px 2px 10px;
    border: 1px solid #fff;
    border-color: #ccc;
  }
  .info-card-container {
    display: grid;
    grid-template-columns: 1fr;
    margin: 1rem;
    gap: 0.75rem;
  }

  .info-card {
    position: relative;
    border: 1px #e0e0e0 solid;
    border-radius: 6px;
    transition: all 0.5s linear;
    padding: 1rem;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    background-color: rgb(255, 255, 255);
  }

  .datetime-info {
    color: rgb(77, 77, 77);
    font-size: 0.75rem;
  }

  .datetime-info > span:first-child {
    margin-right: 0.5rem;
  }

  .datetime-info > span:last-child {
    margin-right: 0.5rem;
  }

  .location-name {
    color: rgb(41, 41, 41);
    margin-top: 0.3rem;
    font-size: 15px;
    font-weight: 500;
  }

  .location-address {
    color: rgb(114, 114, 114);
    margin-top: 0.3rem;
    font-size: 12px;
    max-width: 80%;
  }

  .case-id {
    position: absolute;
    color: rgb(179, 179, 179);
    font-size: 12px;
    text-align: right;
    top: 1rem;
    right: 1rem;
  }

  .past {
    opacity: 0.5;
  }

  .h-intro {
    margin: 1rem;
    color: #4d4d4d;
    font-weight: bold;
    letter-spacing: 0.5px;
    font-size: 16px;
    line-height: 25px;
  }

  .p-intro {
    margin: 1rem 1rem 1rem 1rem;
    font-size: 16px;
    line-height: 25px;
    color: #4d4d4d;
  }

  @media (min-width: 400px) {
    .info-card-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin: 1rem;
    }
  }

  @media (min-width: 600px) {
    .info-card-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin: 1rem;
    }
  }
</style>

<main>
  <h2 class="h-intro">各縣市確診個案「公共場所活動史」</h2>
  <p class="p-intro">
    今日指揮中心公布之個案新增公共場所活動史，《關鍵評論網》匯整指揮中心所公布之個案足跡，讀者可依照縣市進行查詢：
  </p>
  <div class="btn-set">
    {#if countiesList}
      <div><input bind:value={selectedCounty} placeholder="🔎  搜尋縣市" /></div>
      <div style="margin-top: 1rem;">
        <span style="color: gray; font-size: 14px;">更新日期：2021/5/20</span><span
          style="color: gray; font-size: 14px; margin-left: 1.5rem;"
        >資料來源：疾病管制署</span>
      </div>
    {/if}
  </div>
  <div class="info-card-container">
    {#key cardData}
      {#if googleSheetData}
        {#each cardData as footPrint}
          <div transition:fade={{ duration: 300 }} class="info-card" class:past={footPrint.newfootprint !== 1}>
            {#if footPrint.type === 'a'}
              <PlaceIcon />
            {:else}
              <BusIcon />
            {/if}

            <div class="datetime-info">
              <span>{footPrint.date}</span><span>{footPrint.timerange}</span>
              <div class="case-id">{footPrint.caseid}</div>
            </div>
            <div class="location-name">
              {footPrint.loacationname}
              <LocationLink googleMapUrl={footPrint.googlemapurl} />
            </div>
            {#if footPrint.locationaddress !== 0}
              <div class="location-address">{footPrint.locationaddress}</div>
            {/if}
          </div>
        {/each}
      {/if}
    {/key}
  </div>
</main>
